const carsNameData = [
    { label: "BMW", value: "BMW" },
    { label: "Audi", value: "Audi" },
    { label: "Mercedes", value: "Mercedes" },
    { label: "Ford", value: "Ford" },
    { label: "Volkswagen", value: "Volkswagen" },
    { label: "Honda", value: "Honda" },
    { label: "Toyota", value: "Toyota" },
    { label: "Nissan", value: "Nissan" },
    { label: "Porsche", value: "Porsche" },
    { label: "Tesla", value: "Tesla" },
  ];
  
  const carsPriceData = [
    { label: "£5,000", value: 5000 },
    { label: "£10,000", value: 10000 },
    { label: "£15,000", value: 15000 },
    { label: "£20,000", value: 20000 },
    { label: "£25,000", value: 25000 },
    { label: "£30,000", value: 30000 },
    { label: "£40,000", value: 40000 },
    { label: "£50,000", value: 50000 },
    { label: "£60,000", value: 60000 },
    { label: "£70,000", value: 70000 },
  ];
export {carsNameData,carsPriceData}  